import {Component, OnDestroy} from '@angular/core';
import { SubSink } from 'subsink';

@Component({
  template: ``,
})

export class SubscriptionManager implements OnDestroy {

  protected subs: SubSink = new SubSink();

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
